import HttpClient from "./HttpClient"

export default class CountryCode{
    constructor(code){
        this.id = code.id;
        this.language = code.language;
        this.country_name = code.country_name;
        this.country_code = code.country_code;
        this.created_at = code.created_at;
        this.updated_at = code.updated_at;
    }

    static async loadCountryCodes(data) {
        const client = new HttpClient();
        const response = await client.instance.get("countryCodes", data);
        const countryCodes = [];
        response.data.forEach(code => {
            countryCodes.push(new CountryCode(code));
        });
        return countryCodes;
    }

    toString(){
        return this.country_code + " - " + this.country_name;
    }
}